<template>
    <div>
        <b-form-group v-for="(val,index) in value"
                      :key="index"
                      :label="`value[${index}]`"
                      label-cols-sm="1">
            <b-form-input :value="val"></b-form-input>
        </b-form-group>
        <b-btn @click.prevent="value.push(null)">Add</b-btn>
    </div>
</template>

<script>
import valueCmp from "./mixins/valueCmp";

export default {
    mixins: [valueCmp],
}
</script>

<style scoped>

</style>
